import { render, staticRenderFns } from "./EditorLinkModal.vue?vue&type=template&id=1933b30c&"
import script from "./EditorLinkModal.vue?vue&type=script&lang=js&"
export * from "./EditorLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports